import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["length", "height", "depth", "number", "result", "error",
                    "inLength", "inHeight", "inDepth",
                    "outLength", "outHeight", "outDepth", "message"]
  static values = { url: String, useFormRule: Boolean }

  test() {
    const body = {
      length: this.lengthTarget.value,
      height: this.heightTarget.value,
      depth:  this.depthTarget.value,
      number: this.numberTarget.value
    }

    if (this.useFormRuleValue) {
      const ruleField = document.querySelector('textarea[name="category[specific_rule_code]"]')
      if (ruleField) body.rule_code = ruleField.value
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch(this.urlValue, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify(body)
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          this.errorTarget.textContent = `Error: ${data.error}`
          this.errorTarget.style.display = 'block'
          this.resultTarget.style.display = 'none'
          return
        }

        this.errorTarget.style.display = 'none'
        this.resultTarget.style.display = 'block'

        this.inLengthTarget.textContent  = data.input.length
        this.inHeightTarget.textContent  = data.input.height
        this.inDepthTarget.textContent   = data.input.depth
        this.outLengthTarget.textContent = data.output.length
        this.outHeightTarget.textContent = data.output.height
        this.outDepthTarget.textContent  = data.output.depth
        this.messageTarget.textContent   = data.output.message || ''
      })
      .catch(err => {
        this.errorTarget.textContent = `Request failed: ${err.message}`
        this.errorTarget.style.display = 'block'
        this.resultTarget.style.display = 'none'
      })
  }
}
